
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import difference from 'lodash.difference'
import searchString from 'search-string';
import Footer from './components/Footer.vue';
import { Icon } from './types'
import { loadMaterialIcons } from './api/index'

interface State {
  icons: Icon[];
  searchText: string;
  tags: string[];
  categories: string[];
}

const filter = (icons: Icon[], searchText: string, categories: string[], tags: string[]) => {
  return icons.filter((icon: Icon) => {
    if (searchText && icon.name.indexOf(searchText) === -1 ||
        tags.length > 0 && difference(tags, icon.tags).length > 0 ||
        categories.length > 0 && difference(categories, icon.categories).length > 0) {
      return false
    }
    return true
  })
}

export default defineComponent({
  name: 'App',
  components: {
    Footer,
  },
  setup() {
    const state = reactive<State>({
      icons: [],
      searchText: "",
      tags: [],
      categories: [],
    })
    onMounted(async () => {
      const results = await loadMaterialIcons()
      results.flat().forEach(data => {
        state.icons.push(data)
      })
    })
    const onChange = (value: string) => {
      const parsedQuery = searchString.parse(value)
      const { conditionArray } = parsedQuery
      const grouped = conditionArray.reduce((acc: any, { keyword, value }: any) => {
        if (!acc[keyword]) {
          acc[keyword] = []
        }
        acc[keyword].push(value)
        return acc
      }, {})

      state.searchText = parsedQuery.getAllText()
      state.tags = grouped?.['tag'] || []
      state.categories = grouped?.['category'] || []
    }

    return {
      ...toRefs(state),
      filter,
      onChange,
    }
  }
});
